import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from "primereact/toast";

import { useReport } from "../context/report";
import { useAuth } from "../context/auth";

import Menu from "../components/Menu";
import Report from "../components/Report";

import api from "../services/api";
import souzacambos from "../services/souzacambos";

const options = [
    { label: 'METRAGEM PRODUZIDA', value: 'metragem' },
    { label: 'METRAGEM POR ARTIGO', value: 'artigo' },
    { label: 'RELATÓRIO GERAL DE PRODUÇÃO', value: 'paradas' },
    { label: 'RELATÓRIO GERAL POR COLABORADOR', value: 'geralcolaborador' },
    { label: 'CONSUMO FIO', value: 'consumofio' },
    { label: 'CORTES', value: 'cortes' },
    { label: 'CORTES (NOVO)', value: 'cortestecido' },
    { label: 'TEARES COM EFICIÊNCIA ABAIXO DE', value: 'eficienciaabaixo' },
    { label: 'EFICIÊNCIA BAIXA POR GRUPO', value:'eficienciabaixagrupo' },
    { label: 'EFICIÊNCIA DE ENGRUPAGEM', value: 'engreeng'},
    { label: 'RELATÓRIO DE ROLO E URDUME', value: 'rolo' },
    { label: 'RELATÓRIO DIÁRIO DE PRODUÇÃO', value: 'producao' },
    { label: 'GRÁFICOS DE EFICIÊNCIA DE PRODUÇÃO', value: 'producaogeral' },
    { label: 'GRÁFICOS DE EFICIÊNCIA REAL', value: 'eficienciareal' },
    { label: 'QUEBRAS DE TRAMA E URDUME', value: 'quebras' },
    { label: 'QUEBRAS DE TRAMA POR TEAR', value: 'quebrastear' },
    { label: 'QUEBRAS ENG TEC', value: 'quebrasengomagemtecelagem' },
    { label: 'QUEBRAS POR HORA', value: 'quebrastempos' },
    { label: 'QUEBRAS POR CMPX', value: 'quebrascemmil' },
    { label: 'RESÍDUOS', value: 'residuos' },
    { label: 'TESTE DE GOMA', value: 'testegoma' },
    { label: 'TESTE DE GOMA POR ROLADA', value: 'testegomarolada' },
    { label: 'RELATÓRIO PRODUÇÃO REAL', value: 'producaoreal' },
    { label: 'PONTOS 1º QUALIDADE', value: 'pontosprimeiraqualidade' },
];

export default function Relatorios() {
    const [optionsT, setOptionsT] = useState([]);

    const [data, setData] = useState(new Date());
    const [grupos, setGrupos] = useState([]);
    const [turma, setTurma] = useState('');
    const [turmas, setTurmas] = useState([]);
    const [reports, setReports] = useState([]);
    const [type, setType] = useState('');
    const [engType, setEngType] = useState([]);
    const [rolo, setRolo] = useState('');
    const [rolada, setRolada] = useState('');
    const [eficiencia, setEficiencia] = useState(85);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [groupOptions, setGroupOptions] = useState([]);

    const toast = useRef(null);
    const report = useReport();

    const { user } = useAuth();

    const groupedItemTemplate = (option) => {
        return (
            <div className="p-d-flex p-ai-center">
                <Button className="p-button-rounded" label={option.label} onClick={() => {
                    let copy = [...grupos];
                    option.items.forEach(element => {
                        let find = copy.indexOf(element.value);
                        if (find === -1) {
                            copy.push(element.value)
                        } else {
                            copy.splice(find, 1);
                        }
                    });
                    setGrupos(copy);
                }} />
            </div>
        )
    }

    const handleSubmit = () => {
        if (initialDate === '' || finalDate === '' || type === '') {
            return;
        }
        let json;
        if (type === 'producao' || type === 'eficienciaabaixo' || type === 'eficienciabaixagrupo') {
            json = {
                "data": data.getFullYear() + '-' + String((data.getMonth() + 1)).padStart(2, '0') + '-' + String(data.getDate()).padStart(2, '0'),
                "tipo": type,
                "turma_id": turma
            }

            if(type === 'eficienciaabaixo' && eficiencia <= 100 && eficiencia !== null) {
                json.eficiencia = eficiencia;
            } else if(type === 'eficienciaabaixo') {
                toast.current.show({ summary: "Aviso", severity: "warn", detail: "Eficiência deve ser um número de 0 a 100" })
                return;
            }
        } else if(type === 'residuos') {
            let formated1 = initialDate.getFullYear() + '-' + String((initialDate.getMonth() + 1)).padStart(2, '0') + '-' + String(initialDate.getDate()).padStart(2, '0');
            let formated2 = finalDate.getFullYear() + '-' + String((finalDate.getMonth() + 1)).padStart(2, '0') + '-' + String(finalDate.getDate()).padStart(2, '0');
            souzacambos.get(`relatorio_residuos/${formated1}/${formated2}`).then((response) => {
                report.setData(response.data.dados);

                toast.current.show({ summary: 'Concluído', severity: 'success', detail: response.data.message });
            }).catch((error) => {
                toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response.data.message })
            });

            return;
        } else {
            json = {
                "data_inicial": initialDate.getFullYear() + '-' + String((initialDate.getMonth() + 1)).padStart(2, '0') + '-' + String(initialDate.getDate()).padStart(2, '0'),
                "data_final": finalDate.getFullYear() + '-' + String((finalDate.getMonth() + 1)).padStart(2, '0') + '-' + String(finalDate.getDate()).padStart(2, '0'),
                "grupos": grupos,
                "rolo": rolo,
                "rolada": rolada,
                "tipo": type,
                "turmas": turmas
            }

            if(type === 'engreeng') {
                json.parada_id = engType;
            }
        }

        api.post('relatorios', json).then((response) => {
            report.setData(response.data.dados);
            report.setDataReal(response.data.dados2)

            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: error.response.data.message || error.message
            });
        });
    }

    useEffect(() => {
        api.get('cadastros/turmas').then((response) => {
            setOptionsT(response.data);
        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });

        if(user.role !== 'admin') {
            api.get(`relatorios-lista/${user.id}`).then(response => {
                setReports(response.data);
            }).catch(error => {
                setReports([]);
            });
        } else {
            setReports(options);
        }

       
        api.get('sala').then((response) => {
            let sala = response.data.sala;
            let config = response.data.config;

            var grouped = [];
            for (let i = 1; i <= config.grupos; i++) {
                let items = [];
                sala.forEach((element) => {
                    if(parseInt(element.grupo) === i) {
                        items.push({
                            label: "T" + element.tear,
                            value: element.tear
                        });
                    }
                });

                grouped.push({
                    label: "Grupo " + i,
                    items: items
                });
            }
            setGroupOptions(grouped)

        }).catch((error) => {
            toast.current.show({
                summary: 'Ocorreu um Erro',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, [user]);

    return (
        <div style={{
            opacity: report.printing ? '0.05' : ''
        }}>
            <Menu />
            <Toast ref={toast} />
            <Card header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start">
                    <h1 className="p-m-2">Relatórios</h1>
                    <Button className="p-button-primary p-m-2" icon="pi pi-search" onClick={handleSubmit} />
                </div>
            )} className="p-m-3">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col">
                        <label htmlFor="type">Relatório de</label>
                        <Dropdown
                            options={reports}
                            onChange={e => {
                                setType(e.value);
                                report.setData(null);
                            }}
                            placeholder="Escolha um Tipo de Relatório"
                            value={type}
                        />
                    </div>
                    {type === 'engreeng' && (
                        <>
                            <div className="p-field p-col">
                                <label htmlFor="">Tipo</label>
                                <MultiSelect 
                                    onChange={e => setEngType(e.value)}
                                    options={[
                                        { label: 'Engrupagem', value: 1 },
                                        { label: 'Reengrupagem', value: 2 }
                                    ]}
                                    placeholder="Escolha o Tipo"
                                    value={engType}
                                />
                            </div>
                        </>
                    )}
                    {type === 'rolo' || type === 'testegoma' ? (
                        <>
                            <div className="p-field p-col">
                                <label htmlFor="rolo">Rolo: </label>
                                <InputText
                                    placeholder="Exemplo: p14"
                                    onChange={e => setRolo(e.target.value)}
                                    onKeyPress={e => e.key === 'Enter' ? handleSubmit() : null}
                                    value={rolo}
                                    style={{ minWidth: "200px" }}
                                />
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="rolada">Rolada: </label>
                                <InputText
                                    placeholder="Exemplo: 185"
                                    onChange={e => setRolada(e.target.value)}
                                    style={{ minWidth: "200px" }}
                                    value={rolada}
                                />
                            </div>
                        </>

                    ) : null}
                    {type !== 'producao' && type !== 'eficienciabaixagrupo' && type !== 'eficienciaabaixo' ? (
                        <>
                            <div className="p-field p-col">
                                <label htmlFor="turmas">Turmas</label>
                                <MultiSelect
                                    onChange={e => setTurmas(e.value)}
                                    optionLabel="nome"
                                    optionValue="id"
                                    options={optionsT}
                                    placeholder="Selecione as Turmas"
                                    value={turmas}
                                />
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="grupos">Grupos</label>
                                <MultiSelect
                                    optionGroupTemplate={groupedItemTemplate}
                                    options={groupOptions}
                                    optionGroupLabel="label"
                                    optionGroupChildren="items"
                                    onChange={e => setGrupos(e.value)}
                                    maxSelectedLabels={6}
                                    selectedItemsLabel="{0} teares selecionados"
                                    placeholder="Selecione os Grupos"
                                    value={grupos}
                                />
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="data_inicial">Data Inicial</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setInitialDate(e.value)}
                                    style={{ minWidth: "200px" }}
                                    value={initialDate}
                                />
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="data_final">Data Final</label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setFinalDate(e.value)}
                                    style={{ minWidth: "200px" }}
                                    value={finalDate}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            {type === 'eficienciaabaixo' && (
                                <div className="p-field p-col">
                                    <label htmlFor="eficiencia">Eficiência abaixo de: </label>
                                    <InputNumber 
                                        onChange={e => setEficiencia(e.value)}
                                        placeholder="Digite a eficiência"
                                        value={eficiencia}
                                    />
                                </div>
                            )}
                            <div className="p-field p-col">
                                <label htmlFor="turmas">Turmas</label>
                                <Dropdown
                                    onChange={e => setTurma(e.value)}
                                    optionLabel="nome"
                                    optionValue="id"
                                    options={optionsT}
                                    placeholder="Selecione a Turma"
                                    value={turma}
                                />
                            </div>
                            <div className="p-field p-col">
                                <label htmlFor="data">Data: </label>
                                <Calendar
                                    dateFormat="dd/mm/yy"
                                    mask="99/99/9999"
                                    onChange={e => setData(e.value)}
                                    value={data}
                                />
                            </div>
                        </>
                    )}
                </div>
                <Report 
                    type={type}
                />
            </Card>
        </div>
    )
}